/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getBuildingComponentTypeList = (payload, callback) =>
  req.list(
    c.GET_BUILDING_COMPONENT_TYPE,
    'api/v1/rpt/administrator/buildings/settings/building_components',
    payload,
    callback
  );

export const getSingleComponentType = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUILDING_COMPONENT_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_components/${id}`,
    payload,
    callback
  );

export const createBuildComponentType = (payload, callback) =>
  req.create(
    c.CREATE_BUILDING_COMPONENT_TYPE,
    'api/v1/rpt/administrator/buildings/settings/building_components',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateBuildComponentType = (id, payload, callback) =>
  req.update(
    c.UPDATE_BUILDING_COMPONENT_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_components/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeBuildComponentType = (id, payload, callback) =>
  req.remove(
    c.REMOVE_BUILDING_COMPONENT_TYPE,
    `api/v1/rpt/administrator/buildings/settings/building_components/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION_LIST,
    `api/v1/rpt/administrator/settings/ordinance_revisions`,
    payload,
    callback
  );

  export const clearItem = (constant, value) => req.setItem(constant, value);

